import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TramiteIcaVariedadVegetalDto } from '../dto/tramites/tramite-ica-variedad-vegetal.dto';

@Injectable({
  providedIn: 'root',
})
export class TramiteIcaService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/ica/tramite/registrar-tramite';

  constructor(private http: HttpClient) {}

  crearTramiteVariedadVegetal(
    data: TramiteIcaVariedadVegetalDto
  ): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${this.baseUrl}`, data);
  }
}
